__turbopack_context__.v({
  "black": "o1uuoW_black",
  "black100": "o1uuoW_black100",
  "black1000": "o1uuoW_black1000",
  "black200": "o1uuoW_black200",
  "black300": "o1uuoW_black300",
  "black400": "o1uuoW_black400",
  "black500": "o1uuoW_black500",
  "black600": "o1uuoW_black600",
  "black700": "o1uuoW_black700",
  "black800": "o1uuoW_black800",
  "black900": "o1uuoW_black900",
  "blue200": "o1uuoW_blue200",
  "blue400": "o1uuoW_blue400",
  "blue600": "o1uuoW_blue600",
  "blue800": "o1uuoW_blue800",
  "blue900": "o1uuoW_blue900",
  "green200": "o1uuoW_green200",
  "green400": "o1uuoW_green400",
  "green600": "o1uuoW_green600",
  "green800": "o1uuoW_green800",
  "green900": "o1uuoW_green900",
  "pageHeaderWithForm": "o1uuoW_pageHeaderWithForm",
  "pink200": "o1uuoW_pink200",
  "pink400": "o1uuoW_pink400",
  "pink600": "o1uuoW_pink600",
  "pink800": "o1uuoW_pink800",
  "purple200": "o1uuoW_purple200",
  "purple400": "o1uuoW_purple400",
  "purple600": "o1uuoW_purple600",
  "purple800": "o1uuoW_purple800",
  "purple900": "o1uuoW_purple900",
  "red200": "o1uuoW_red200",
  "red400": "o1uuoW_red400",
  "red600": "o1uuoW_red600",
  "red800": "o1uuoW_red800",
  "red900": "o1uuoW_red900",
  "sky1000": "o1uuoW_sky1000",
  "useCaseLendingRed": "o1uuoW_useCaseLendingRed",
  "white": "o1uuoW_white",
  "yellow200": "o1uuoW_yellow200",
  "yellow400": "o1uuoW_yellow400",
  "yellow600": "o1uuoW_yellow600",
  "yellow800": "o1uuoW_yellow800",
  "yellow900": "o1uuoW_yellow900",
});
